import { ArrowRight } from "lucide-react"

const Hero = () => {
  return (
    <section id="accueil" className="relative h-screen flex items-center">
      {/* Image d'arrière-plan avec effet parallax */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/50 z-10"></div>
        <div className="relative w-full h-full" style={{ aspectRatio: "16/9" }}>
          <img
            src="/car-hero.webp"
            alt="Ferrailleur épaviste Saint-Étienne - Enlèvement gratuit de véhicules et rachat de métaux en Loire, Haute-Loire et Rhône"
            className="w-full h-full object-cover parallax-bg"
            width="1920"
            height="1080"
            fetchPriority="high"
            style={{ objectPosition: "center center" }}
          />
        </div>
      </div>

      {/* Contenu */}
      <div className="container mx-auto px-4 relative z-20">
        <div className="max-w-2xl text-white">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            Ferrailleur – Épaviste à Saint-Étienne<br />Intervention en Loire & Haute Loire
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-100">
            Spécialiste de l'<strong>enlèvement gratuit de véhicules</strong> et du <strong>rachat de métaux</strong> (cuivre, laiton, aluminium) dans la
            Loire, la Haute-Loire et le Rhône depuis 2010.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition-colors inline-flex items-center justify-center"
              aria-label="Demander un devis gratuit pour enlèvement d'épave à Saint-Étienne"
            >
              Demander un devis gratuit
              <ArrowRight className="ml-2 h-5 w-5" />
            </a>
            <a
              href="#contact"
              className="border-2 border-white hover:bg-white hover:text-green-700 text-white font-bold py-3 px-6 rounded-lg transition-colors inline-flex items-center justify-center"
              aria-label="Contacter ferrailleur épaviste à Saint-Étienne"
            >
              Appelez-nous
            </a>
          </div>
        </div>
      </div>

      {/* Commentaire pour animation GSAP future */}
      {/* 
        Animation GSAP à implémenter:
        - Apparition progressive du texte
        - Légère animation du bouton CTA
      */}
    </section>
  )
}

export default Hero
